export default __webpack_public_path__ + "static/B0149-7ec34e3267cf1e071a3d071512f71624.png";